import axios from "axios";

export const API_BASE_URL =
  "https://apis.fpfch.gob.mx/api/v1";
export const API_LOGIN_URL = "/session/login";
export const API_FILA_URL = "/operator/queue";
export const API_CITAS_URL = "/operator/scheduled";
export const API_WIP_URL = "/operator/wip";
export const API_PROC_VIEW_URL = "/operator/reviewproc";
export const API_PROC_FILE_LIST_URL = "/files"; // req id_proc, id_proc_type
export const API_PROC_FILE_REJECT_URL = "/files/reject"; // expects ID, comment params, POST
export const API_PROC_FILE_ACCEPT_URL = "/files/accept"; // expects ID param, POST
export const API_ASSIGN_PROC_URL = "/operator/assignproc";
export const API_CHECK_TAG_URL = "/tags/isvalid";
export const API_APPOINTMENT_DETAIL_URL = "/appointments";
export const API_GET_DATA_FOR_PASS_RESET_URL = "/user/getrtoken";
export const API_GET_DATA_FOR_EMAIL_CHANGE_URL = "/user/getetoken";
export const API_UPDATE_PASS_URL = "/user/updatepass";
export const API_UPDATE_EMAIL_URL = "/user/updateemail";
// const uploadProgress = (p) => {
//   console.log("upload...", p);
//   console.log(appg.getApiKey())
//   console.trace();
// };

// const downloadProgress = (p) => {
//   console.log("download...", p);
//   console.log(appg.getApiKey())
//   console.trace();
// };

const a = axios.create({
  baseURL: API_BASE_URL,

  // headers: { Authorization: `Bearer ${appg.getApiKey()}` },

  // onDownloadProgress: downloadProgress,
  // onUploadProgress: uploadProgress,
});

a.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("apiKey")}`;
  return config;
});

export default a;
